import * as types from './types'

export const setUsers = (payload: any) => ({
  type: types.SET_USERS,
  payload,
})

export const updateUserInState = (payload: any) => ({
  type: types.UPDATE_USER,
  payload,
})
